
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('pageContent', { jumbo: 'getJumbotron' })
    }
  };
